import { EMPTY_CELL, escapeHtml } from './escape-html';

/**
 * The "Permit #" column on the permits lists.
 *
 * A permit has no number until it's approved (TLC, 30 Sep), so this must be a link only
 * when there's a number, and a plain dash otherwise - the column's own linkAction can't
 * do that (it wraps every cell, underlining the dash so it reads as "="). So the link is
 * built here instead: numbered rows link to the permit detail; un-numbered rows are a
 * plain, non-link dash.
 *
 * Takes the whole row (the column's `value` is '') to read both the number and the id.
 * Painted through [innerHTML], so the number (letters+digits) is escaped and the id (a
 * ULID) is URL-encoded.
 */
export function permitNumberCell(row: unknown): string {
    const r = (row ?? {}) as { permitNumber?: unknown; id?: unknown };
    const num = typeof r.permitNumber === 'string' ? r.permitNumber.trim() : '';

    if (!num) {
        return EMPTY_CELL;
    }

    const id = typeof r.id === 'string' ? r.id : '';
    if (!id) {
        return escapeHtml(num);
    }

    return `<a href="/crm/permits/${encodeURIComponent(id)}">${escapeHtml(num)}</a>`;
}
